<template>
  <DefaultButton
    design-type="primary"
    design-variant="default"
    @click="callOrShowPhoneNumber">
    <template v-if="!isPhoneNumberShown">
      Être assisté(e) par téléphone <span class="ml-2">&#128222;</span>
    </template>
    <template v-else-if="!isMobile">
      Appelez dès à présent le <strong>{{ workspacePhoneNumber | phone }}</strong> <span class="ml-2">&#128222;</span>
    </template>
  </DefaultButton>
</template>

<script>
import BrowserService from "@/services/BrowserService"
import DefaultButton from "@/components/ui/DefaultButton"
import { mapState } from "vuex"

export default {
  name: "AssistanceButton",
  components: { DefaultButton },
  data() {
    return {
      isPhoneNumberShown: false,
      isMobile: BrowserService.isMobile()
    }
  },
  computed: { ...mapState({ workspacePhoneNumber: state => state.workspace.phone_number }) },
  methods: {
    callOrShowPhoneNumber() {
      if (this.isPhoneNumberShown) {
        return
      }
      this.isPhoneNumberShown = true

      if (this.isMobile) {
        window.location.href = `tel:${this.workspacePhoneNumber}`
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>